export enum ProcurementCalendarCategoryRules {
    FruitsVegetablesSpecialFeature = 1,
    AssortmentClassValidity = 2,
    ProductsCanBeOrderedInLxm = 4,
    ProcurementPreviousPeriodRetailPrice = 8
}

(ProcurementCalendarCategoryRules as any).__typeName = 'ProcurementCalendarCategoryRules';